// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifs_container__3Q9qM","list":"Notifs_list__3x3c7","notif":"Notifs_notif__1WFpW","info":"Notifs_info__IP93R"};